export default __webpack_public_path__ + "static/media/agrupmentsBlack.809d8096.svg";